/* unplugin-vue-components disabled */
export default {
  mixins: [ModelValue(Boolean)],
  props: {
    size: {
      type: String,
      default: 'small',
      validator(value) {
        return ['large', 'default', 'small'].includes(value)
      }
    }
  }
}
